export const VENDOR_PRICE_MAX_INTEGER_DIGITS = 10;
export const VENDOR_PRICE_DECIMAL_PLACES = 2;

/** Restricts price input to currency-style values while typing. */
export function sanitizeVendorPriceInput(raw: string): string {
  if (!raw) return "";

  let cleaned = raw.replace(/[^0-9.]/g, "");
  const firstDot = cleaned.indexOf(".");
  if (firstDot !== -1) {
    cleaned =
      cleaned.slice(0, firstDot + 1) +
      cleaned.slice(firstDot + 1).replace(/\./g, "");
  }

  const [intRaw = "", decRaw = ""] = cleaned.split(".");
  let intPart = intRaw.slice(0, VENDOR_PRICE_MAX_INTEGER_DIGITS);
  if (intPart.length > 1) {
    intPart = intPart.replace(/^0+/, "") || "0";
  }

  const decPart = decRaw.slice(0, VENDOR_PRICE_DECIMAL_PLACES);
  const hasDot = firstDot !== -1;

  if (hasDot) {
    if (decRaw.length === 0 && raw.endsWith(".")) {
      return `${intPart || "0"}.`;
    }
    return `${intPart || "0"}.${decPart}`;
  }

  return intPart;
}

export function formatCentsToVendorPriceInput(
  cents: number | null | undefined
): string {
  return cents != null ? (cents / 100).toFixed(2) : "";
}

export function parseVendorPriceInputToCents(value: string): number | null {
  const trimmed = sanitizeVendorPriceInput(value).trim();
  if (!trimmed || trimmed === ".") return null;
  const parsed = parseFloat(trimmed);
  if (Number.isNaN(parsed)) return null;
  return Math.round(parsed * 100);
}

export function isVendorPriceInputValid(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  return parseVendorPriceInputToCents(value) !== null;
}
